// ======================================================================
// File: src/modules/ppe/transport/components/vehicle/VehicleDrawer.jsx
// Module: PPE → Transport
// Purpose:
//   Drawer for adding vehicle to a Transport Request
// ======================================================================

//import React, { useState } from "react";
import React, { useEffect, useState } from "react";
import transportService from "../../services/transportService";


// ======================================================================
// COMPONENT
// ======================================================================

export default function VehicleDrawer({
  transportId,
  onClose,
  onSaved,
}) {

  const [saving, setSaving] = useState(false);
  const [taxClassifications, setTaxClassifications] = useState([]);
  const [loadingTaxClassifications, setLoadingTaxClassifications] = useState(false);
  
  const [form, setForm] = useState({
    transport_request_id: transportId,
    vehicle_no: "",
    vehicle_type: "",
    driver_name: "",
    driver_mobile: "",
    license_no: "",
    freight_amount: "",
    loading_charge: "",
    unloading_charge: "",
    detention_charge: "",
    other_charges: "",
    tax_classification_id: "",
    tax_type: "CGST_SGST",
  });

  // ------------------------------------------------------------------
  // HANDLE CHANGE
  // ------------------------------------------------------------------
    // ------------------------------------------------------------------
  // LOAD SAC TAX CLASSIFICATIONS
  // ------------------------------------------------------------------
  useEffect(() => {
    const loadTaxClassifications = async () => {
      try {
        setLoadingTaxClassifications(true);

        const response =
          await transportService.getTaxClassifications("SAC");

        const rows = Array.isArray(response)
          ? response
          : Array.isArray(response?.data)
          ? response.data
          : [];

        setTaxClassifications(rows);
      } catch (err) {
        console.error("Failed to load SAC classifications:", err);
        setTaxClassifications([]);
        alert("Failed to load SAC tax classifications");
      } finally {
        setLoadingTaxClassifications(false);
      }
    };

    loadTaxClassifications();
  }, []);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  
  // ------------------------------------------------------------------
  // SAVE VEHICLE
  // ------------------------------------------------------------------
  const handleSave = async () => {
    if (!form.tax_classification_id) {
      alert("Please select an SAC tax classification");
      return;
    }

    if (!form.tax_type) {
      alert("Please select a GST tax type");
      return;
    }

    try {
      setSaving(true);

      const payload = {
        ...form,
        tax_classification_id: Number(form.tax_classification_id),
      };

      await transportService.addVehicle(payload);

      if (onSaved) onSaved();
    } catch (err) {
      console.error("Failed to add vehicle:", err);

      const message =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Failed to add vehicle";

      alert(message);
    } finally {
      setSaving(false);
    }
  };


  // ------------------------------------------------------------------
  // RENDER
  // ------------------------------------------------------------------
  return (
    <div className="drawer-overlay">
      <div className="drawer-panel">

        {/* ============================================================
            HEADER
        ============================================================ */}
        <div className="drawer-header">
          <h5>Add Vehicle</h5>
          <button className="btn-close" onClick={onClose}></button>
        </div>

        {/* ============================================================
            BODY
        ============================================================ */}
        <div className="drawer-body">

          <div className="mb-3">
            <label>Vehicle No</label>
            <input
              name="vehicle_no"
              className="form-control"
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label>Vehicle Type</label>
            <input
              name="vehicle_type"
              className="form-control"
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label>Driver Name</label>
            <input
              name="driver_name"
              className="form-control"
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label>Driver Mobile</label>
            <input
              name="driver_mobile"
              className="form-control"
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label>License No</label>
            <input
              name="license_no"
              className="form-control"
              onChange={handleChange}
            />
          </div>

          <hr />

          <h6>Freight Details</h6>

          <div className="mb-3">
            <label>Freight Amount</label>
            <input
              name="freight_amount"
              type="number"
              className="form-control"
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label>Loading Charge</label>
            <input
              name="loading_charge"
              type="number"
              className="form-control"
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label>Unloading Charge</label>
            <input
              name="unloading_charge"
              type="number"
              className="form-control"
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label>Detention Charge</label>
            <input
              name="detention_charge"
              type="number"
              className="form-control"
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label>Other Charges</label>
            <input
              name="other_charges"
              type="number"
              className="form-control"
              onChange={handleChange}
            />
          </div>
          
          <hr />

          <h6>GST Details</h6>

          <div className="mb-3">
            <label>SAC Tax Classification</label>
            <select
              name="tax_classification_id"
              className="form-select"
              value={form.tax_classification_id}
              onChange={handleChange}
              disabled={loadingTaxClassifications}
              required
            >
              <option value="">
                {loadingTaxClassifications
                  ? "Loading SAC classifications..."
                  : "Select SAC classification"}
              </option>

              {taxClassifications.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.tax_code} - {item.description}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <label>GST Tax Type</label>
            <select
              name="tax_type"
              className="form-select"
              value={form.tax_type}
              onChange={handleChange}
              required
            >
              <option value="CGST_SGST">CGST + SGST</option>
              <option value="IGST">IGST</option>
            </select>
          </div>


        </div>

        {/* ============================================================
            FOOTER
        ============================================================ */}
        <div className="drawer-footer">
          <button
            className="btn btn-secondary me-2"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="btn btn-primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? "Saving..." : "Add Vehicle"}
          </button>
        </div>

      </div>
    </div>
  );
}
